export const publicLayoutStyles = (theme) => ({
  root: { height: '100vh', display: 'flex', flexDirection: 'column' },
  headerWrapper: { backgroundColor: '#FFFFFF', height: '80px', display: 'flex', alignItems: 'center' },
  headerLeftContent: {
    flex: 1,
    paddingLeft: '6%',
    paddingTop: '1em',
    height: '100%',
  },
  headerRightContent: { marginRight: '6%' },
  bodyWrapper: { flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-center', padding: '1em' },
  footerWrapper: {
    backgroundColor: '#000000',
    color: '#f8f7f7',
    minHeight: '120px',
    textAlign: 'center',
  },
  footerContent: {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 30,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 15,
    },
  },
  footerLink: { margin: '0 2%', color: '#f8f7f7', textDecoration: 'underline', cursor: 'pointer' },
})
